export { default as FacebookIcon } from '~icons/akar-icons/facebook-fill';
